import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./sync.svg?react";

export const SyncIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
